import React from "react";

import { useFilteredMetrics } from "../hooks/use-filtered-metrics";
import { useFormulaBuilder } from "../hooks/use-formula-builder";

import { NoMetricTable } from "./no-metric-table";
import { PreviewMetricTable } from "./preview-table";

export const Preview = () => {
  const { selectedMetricIds } = useFormulaBuilder();
  const { getMetricById } = useFilteredMetrics();
  const metrics = selectedMetricIds.map(getMetricById).filter(Boolean);

  return (
    <div className="[grid-area:preview]">
      <div className="text-xs font-medium  pb-1">
        <span className="tracking-wider">PREVIEW</span>
        <span className="text-xxs ml-1">(SAMPLE DATA)</span>
      </div>
      <div className="border border-gray-2 rounded-md max-h-[13rem] overflow-y-hidden">
        {metrics.length > 0 ? (
          <PreviewMetricTable metrics={metrics} />
        ) : (
          <NoMetricTable />
        )}
      </div>
    </div>
  );
};
